module.exports = __webpack_public_path__ + "img/bgloginblue.f3498964.png";